import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0D00DataDiv } from 'src/app/commons/kymw0d/kymw0d00/kymw0d00.model'; 
import { KYMW9200Model } from './kymw9200.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetCatalogInfoListService } from './api-services/get-catalog-info-list.service';
import { ImportCatalogCalendarService } from './api-services/import-catalog-calendar.service';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { FileUploadService, FileAccept } from './../../../commons/kymw02/file-upload/file-upload.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';

/**
 * 企画回管理画面を管理するクラス
 *
 * @export KYMW9200Component
 * @class KYMW9200Component
 */
@Component({
  selector: 'app-kymw9200',
  templateUrl: 'kymw9200.component.html',
  styleUrls: ['kymw9200.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9200Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  KYMW9200Model: KYMW9200Model = new KYMW9200Model();

  KYMW0D00InputVO: KYMW0D00InputModel = new KYMW0D00InputModel();

  /** ファイルリファレンス */
  public fileRef: File = null;

  @ViewChild('txti_OrderCodeFrom', { static: true }) txti_OrderCodeFrom: OrderCodeTextInputComponent;
  @ViewChild('txti_OrderCodeTo', { static: true }) txti_OrderCodeTo: OrderCodeTextInputComponent;
  @ViewChild('dtg_CatalogList', { static: true }) dtg_CatalogList: FlexGrid;


  /**
   *Creates an instance of KYMW9200Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetCatalogInfoListService} getCatalogInfoListService
   * @param {ImportCatalogCalendarService} importCatalogCalendarService 
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW9200Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getCatalogInfoListService: GetCatalogInfoListService,
    private importCatalogCalendarService: ImportCatalogCalendarService,
    private fileUploadService: FileUploadService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9200Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9200';

    // 行ヘッダの幅を0にしてレイアウト設定
    this.dtg_CatalogList.rowHeaders.columns[0].width = 0;

    // 権限取得
    if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {    // 「2：フルコントロール」以外の場合
      this.KYMW9200Model.disabledCatalogCalendarToFlg = true;
    }

    // グリッドの初期選択行はなしとする
    this.dtg_CatalogList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_CatalogList.select(-1, -1);
    });
  }

  /**
   * 表示ボタンを押下した時に呼び出されるメソッド。
   *
   * @returns {void}
   * @memberof KYMW9200Component
   */
  public eventDisplay_CLICKHandler(): void {
    const orderCodeFrom = this.KYMW9200Model.orderCodeFrom;
    const orderCodeTo = this.KYMW9200Model.orderCodeTo;

    if (PlessViewUtilsSub.isEmpty(this.KYMW9200Model.orderCodeFrom)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(From)']);
      return;
    }
    if (!this.txti_OrderCodeFrom.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.KYMW9200Model.orderCodeTo)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(To)']);
      return;
    }
    if (!this.txti_OrderCodeTo.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }

    if (this.KYMW9200Model.orderCodeTo < this.KYMW9200Model.orderCodeFrom) {
      this.dialogService.openAlertGetMessage('E0125', ['受注コード(From)', '受注コード(To)'] );
      return;
    }

    const vo = {
      orderCodeFrom,
      orderCodeTo,
    };
    // API呼び出し
    this.getCatalogInfoListService.execute(this.KYMW9200Model, vo);
  }

  /**
   * 企画カレンダー取込ボタンを押下したときに呼び出されるメソッド
   *
   * @memberof KYMW9200Component
   */
  public eventCatalogCalendar_CLICKHandler(): void {
    this.fileCatalogCalendarUpload();
  }

  /**
   * 企画カレンダー取込
   *
   * @private
   * @memberof KYMW9200Component
   */
  private fileCatalogCalendarUpload(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
      // 企画カレンダー取込処理
      this.importCatalogCalendarService.execute(selectedFiles[0], (data: any) => {
        const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
        // 画面ＩＤ
        inpVO.dispId = 'KYMW9200';
        // データ区分
        inpVO.dataDiv = '';
        // 正常件数
        inpVO.normalNum = data.NormalCount;
        // 注意件数
        inpVO.attentionNum = data.AttentionCount;
        // 異常件数
        inpVO.abnormalNum = data.AbnormalityCount;
        // ＤＢ更新件数
        inpVO.updateNum = data.DBExecuteCount;
        // 処理件数
        inpVO.manageNum = data.TotalExecuteCount;

        const ref = this.dialogService.openModal(KYMW0D00Component);
        const inst = ref.componentInstance as KYMW0D00Component;

        inst.parent = this;
        inst.setInterfaceParam(inpVO);
        inst.closeFunction = () => {
          ref.close();
        };
      });
    }
  }, [FileAccept.CSV]);
  }

}
